import Picker from '@emoji-mart/react'
import { init } from 'emoji-mart'
import data from '@emoji-mart/data'
import { emojis, recordToEmojiMart, stickers } from '../../../global-components/src/utils/text'
import { useTheme } from '../../../global-components/src';
import { useEffect, useRef, useState } from 'react';
import GifModal from '../../gif-picker/gif-picker';
import { Icon } from '../../../global-components/src/components/icon';
import './style.css';

interface Props {
  onSelect: (emoji: string) => void
  show: boolean
  bottom?: string | number
  setShow: (val: boolean) => void
  handleClickGif?: (gif: string) => void;
  initialTab?: Tab;
}

export type Tab = 'stickers' | 'emojis' | 'gifs'

export default function EmojiPickerNative({ onSelect, show, setShow, bottom, handleClickGif, initialTab = 'emojis' }: Props) {
  const { isDarkMode } = useTheme();
  const pacocaEmojis = recordToEmojiMart(emojis);
  const pacocaStickers = recordToEmojiMart(stickers);
  const pickerRef = useRef<HTMLDivElement>(null);
  const [activeTab, setActiveTab] = useState<Tab>(initialTab);
  const [initialized, setInitialized] = useState(false);

  useEffect(() => {
    if (show) setActiveTab(initialTab);
  }, [show, initialTab]);

  const stickerCustom = [
    { id: 'pacoca_sticker', name: 'Emojis do Paçoca', emojis: pacocaStickers },
  ]
  const emojiCustom = [
    { id: 'pacoca', name: 'Emojis do Paçoca', emojis: pacocaEmojis },
  ]
  const allCustom = [
    ...emojiCustom,
    ...stickerCustom,
  ]

  useEffect(() => {
    if (!show || initialized) return

    init({
      data,
      custom: allCustom
    }).then(() => setInitialized(true))
  }, [show, initialized])

  useEffect(() => {
    if (!show) return
    const handleClickOutside = (event: MouseEvent) => {
      if (pickerRef.current && !pickerRef.current.contains(event.target as Node)) {
        setShow(false)
      }
    }
    document.addEventListener('mousedown', handleClickOutside)
    return () => document.removeEventListener('mousedown', handleClickOutside)
  }, [show, setShow])

  const handleSelect = (emoji: any) => {
    if (emoji.native) {
      onSelect(emoji.native)
      return
    }
    if (emoji?.id) {
      onSelect(`:${emoji.id}: `)
    }
  }

  const handleTabChange = (tab: Tab) => {
    if (tab === 'gifs' && !handleClickGif) return;
    setActiveTab(tab)
  }

  if (!show) return null

  const theme = isDarkMode ? "dark" : "light"
  const emojiCategories = [
    'pacoca', 'recent', 'people', 'nature', 'foods',
    'activity', 'places', 'objects', 'symbols', 'flags',
  ]
  const categoryIcons = {
    pacoca: { src: '/img/emoji/zack/sorriso.png' },
    pacoca_sticker: { src: '/img/emoji/zack/coracao.png' },
  }

  const emojiSizeSticker = () => {
    if(window.innerWidth <= 320) return 70;
    if(window.innerWidth <= 348) return 80;
    if(window.innerWidth <= 378) return 90;
    if(window.innerWidth <= 405) return 100;
    if(window.innerWidth <= 433) return 110;
    if(window.innerWidth <= 457) return 120;
    if(window.innerWidth <= 850) return 130;
    return 112
  }
  const emojiButtonSizeSticker = () => {
    if(window.innerWidth <= 320) return 95;
    if(window.innerWidth <= 348) return 105;
    if(window.innerWidth <= 378) return 115;
    if(window.innerWidth <= 405) return 125;
    if(window.innerWidth <= 433) return 135;
    if(window.innerWidth <= 457) return 145;
    if(window.innerWidth <= 850) return 155;
    return 112
  }


  const emojiSizeEmoji = () => {
    if(window.innerWidth <= 386) return 33;
    if(window.innerWidth <= 408) return 35;
    if(window.innerWidth <= 432) return 37;
    if(window.innerWidth <= 470) return 40;
    return 45
  }
  const emojiButtonSizeEmoji = () => {
    if(window.innerWidth <= 386) return 38;
    if(window.innerWidth <= 408) return 40;
    if(window.innerWidth <= 432) return 43;
    if(window.innerWidth <= 470) return 45;
    return 50
  }

  const handleSelectGif = (gif: any) => {
    const url = gif?.images?.original?.url || gif?.images?.fixed_height?.url;
    if (!url || !handleClickGif) return;

    setShow(false);
    handleClickGif(url);
  };

  return (
    <div
      ref={pickerRef}
      className={`emoji-picker-wrapper ${activeTab === 'gifs' ? 'emoji-picker-wrapper-gif' : ''}`}
      style={{ bottom }}
    >
      <div className="emoji-picker-tabs" style={{
        display: 'flex',
        borderBottom: '1px solid var(--color-border, #e0e0e0)',
        background: isDarkMode ? '#222' : '#fff',
      }}>
        <button type='button' onClick={() => handleTabChange('emojis')} style={{
          flex: 1, padding: '8px', border: 'none',
          borderBottom: activeTab === 'emojis' ? '2px solid #f5a623' : '2px solid transparent',
          background: 'transparent', cursor: 'pointer',
          fontWeight: activeTab === 'emojis' ? 'bold' : 'normal',
          color: isDarkMode ? '#fff' : '#000',
        }}>
          Emojis
        </button>
        <button type='button' onClick={() => handleTabChange('stickers')} style={{
          flex: 1, padding: '8px', border: 'none',
          borderBottom: activeTab === 'stickers' ? '2px solid #f5a623' : '2px solid transparent',
          background: 'transparent', cursor: 'pointer',
          fontWeight: activeTab === 'stickers' ? 'bold' : 'normal',
          color: isDarkMode ? '#fff' : '#000',
        }}>
          Figurinhas
        </button>
        {handleClickGif && (
          <button type='button' onClick={() => handleTabChange('gifs')} style={{
            flex: 1, padding: '8px', border: 'none',
            borderBottom: activeTab === 'gifs' ? '2px solid #f5a623' : '2px solid transparent',
            background: 'transparent', cursor: 'pointer',
            fontWeight: activeTab === 'gifs' ? 'bold' : 'normal',
            color: isDarkMode ? '#fff' : '#000',
            display: 'flex', alignItems: 'center', justifyContent: 'center', gap: 4,
          }}>
            <Icon name="gif_box" color={isDarkMode ? '#fff' : '#000'} />
            GIF
          </button>
        )}
      </div>

      {/* Only mount the active picker — avoids init race condition */}
      {initialized && activeTab === 'emojis' && (
        <Picker
          data={data}
          custom={emojiCustom}
          categories={emojiCategories}
          categoryIcons={categoryIcons}
          defaultCategory="pacoca"
          emojiSize={emojiSizeEmoji()}
          emojiButtonSize={emojiButtonSizeEmoji()}
          skinTonePosition="none"
          onEmojiSelect={handleSelect}
          theme={theme}
          previewPosition="none"
        />
      )}

      {initialized && activeTab === 'stickers' && (
        <div className='div-stickers'>
          <Picker
            data={data}
            navPosition="none"
            custom={stickerCustom}
            categories={["pacoca_sticker"]}
            categoryIcons={categoryIcons}
            defaultCategory="pacoca_sticker"
            emojiSize={emojiSizeSticker()}
            emojiButtonSize={emojiButtonSizeSticker()}
            perLine={window.innerWidth <=850 ? 3 : 4}
            skinTonePosition="none"
            onEmojiSelect={handleSelect}
            theme={theme}
            previewPosition="none"
          />
        </div>
      )}

      {activeTab === 'gifs' && handleClickGif && (
        <div className="emoji-picker-gif-content">
          <GifModal onSelect={handleSelectGif} />
        </div>
      )}
    </div>
  )
}
